import { ButtonList } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';
import { MouseEventHandler, useCallback } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

type ConversationsTableRowMenuUserProps = {
  /** The user to view the details page of. */
  user: User;
  /** Whether the user is the assigned agent. */
  isAssignee?: boolean;
};

/** Represents the component for viewing the user. */
export const ConversationsTableRowMenuUser = ({
  user,
  isAssignee,
}: ConversationsTableRowMenuUserProps): JSX.Element => {
  const navigate = useAppNavigate();
  const label = `View ${isAssignee ? 'agent' : 'contact'}`;

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    navigate({
      path: '/contacts/user/:id',
      params: { path: { id: user.id } },
    });

    if (isAssignee) {
      ampli.conversationsViewAgentClicked();
    } else {
      ampli.conversationsViewContactClicked();
    }
  }, [navigate, user.id, isAssignee]);

  return <ButtonList.Item onClick={handleClick}>{label}</ButtonList.Item>;
};
